'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _UIScrollOverhang = require('./UIScrollOverhang');

var _UIScrollOverhang2 = _interopRequireDefault(_UIScrollOverhang);

var _renderProp = require('../utils/propTypes/renderProp');

var renderProp = _interopRequireWildcard(_renderProp);

var _refObject = require('../utils/propTypes/refObject');

var _refObject2 = _interopRequireDefault(_refObject);

var _Style = require('../core/Style');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isHorizontal = function isHorizontal(direction) {
  return direction === 'horizontal' || direction === 'both';
};
var isVertical = function isVertical(direction) {
  return direction === 'vertical' || direction === 'both';
};
var validSize = function validSize(size) {
  return typeof size === 'number' ? (0, _Style.remCalc)(size) : size;
};

var DefaultScrollContainer = _styledComponents2.default.div.withConfig({
  displayName: 'UIScrollContainer__DefaultScrollContainer'
})(['height:100%;width:100%;max-height:', ';max-width:', ';overflow-x:', ';overflow-y:', ';'], function (props) {
  return validSize(props.maxHeight);
}, function (props) {
  return validSize(props.maxWidth);
}, function (props) {
  return isHorizontal(props.scrollDirection) ? 'auto' : 'hidden';
}, function (props) {
  return isVertical(props.scrollDirection) ? 'auto' : 'hidden';
});
DefaultScrollContainer.propTypes = {
  children: _react.PropTypes.node,
  maxHeight: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  maxWidth: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string]),
  scrollDirection: _react.PropTypes.oneOf(['horizontal', 'vertical', 'both', 'none']).isRequired
};
DefaultScrollContainer.defaultProps = {
  scrollDirection: 'both'
};

var UIScrollContainer = function (_React$Component) {
  _inherits(UIScrollContainer, _React$Component);

  function UIScrollContainer(props) {
    _classCallCheck(this, UIScrollContainer);

    var _this = _possibleConstructorReturn(this, (UIScrollContainer.__proto__ || Object.getPrototypeOf(UIScrollContainer)).call(this, props));

    _this.refCallback = _this.refCallback.bind(_this);
    return _this;
  }

  _createClass(UIScrollContainer, [{
    key: 'refCallback',
    value: function refCallback(ref) {
      var scrollElementRef = this.props.scrollElementRef;

      if (scrollElementRef) {
        scrollElementRef.current = (0, _reactDom.findDOMNode)(ref);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          maxHeight = _props.maxHeight,
          maxWidth = _props.maxWidth,
          ScrollContainer = _props.ScrollContainer,
          scrollDirection = _props.scrollDirection,
          __scrollElementRef = _props.scrollElementRef,
          rest = _objectWithoutProperties(_props, ['children', 'maxHeight', 'maxWidth', 'ScrollContainer', 'scrollDirection', 'scrollElementRef']);

      return _react2.default.createElement(
        _UIScrollOverhang2.default,
        rest,
        _react2.default.createElement(
          ScrollContainer,
          {
            maxHeight: maxHeight,
            maxWidth: maxWidth,
            ref: this.refCallback,
            scrollDirection: scrollDirection
          },
          children
        )
      );
    }
  }]);

  return UIScrollContainer;
}(_react2.default.Component);

UIScrollContainer.propTypes = _extends({}, _UIScrollOverhang2.default.propTypes, DefaultScrollContainer.propTypes, {
  ScrollContainer: renderProp.getPropType(DefaultScrollContainer),
  scrollElementRef: _refObject2.default
});

UIScrollContainer.defaultProps = _extends({}, _UIScrollOverhang2.default.defaultProps, DefaultScrollContainer.defaultProps, {
  ScrollContainer: DefaultScrollContainer
});

UIScrollContainer.displayName = 'UIScrollContainer';

exports.default = UIScrollContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/scroll/UIScrollContainer.js
// module id = 585
// module chunks = 171